module.exports = __webpack_public_path__ + "Simple-Line-Icons.6ac7320f709ffd2784b4.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/vendor/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.2.2
// module id = ../../../../../src/assets/vendor/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.2.2
// module chunks = styles